module.exports = __webpack_public_path__ + "img/55@2x.94387384.png";